export default __webpack_public_path__ + "static/uipath-robot-blog-9dfc4669de91e012750ab36a56a5f7f4.png";